import { MessageCircle } from 'lucide-react';
import { waLink } from '../lib/constants';
import { trackEvent } from '../lib/analytics';

export const WhatsAppFloat = () => {
  return (
    <a
      href={waLink("Hi FindYourMUA, I'd like to discover an artist.")}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      onClick={() => trackEvent('whatsapp_click', { source: 'floating' })}
      className="fixed bottom-6 left-6 z-40 inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe57] text-white px-4 py-3 shadow-lg transition-colors"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="text-[11px] uppercase tracking-[0.2em] hidden sm:inline">WhatsApp Us</span>
    </a>
  );
};
